// src/reducers/userReducer.js
import {
    GET_MAIN_TABLEBOOKING_SUCCESS,
    GET_MAIN_TABLEBOOKING_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const mainTableBookingReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_MAIN_TABLEBOOKING_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_MAIN_TABLEBOOKING_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };